import { Injectable } from '@angular/core';
import { interval, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import moment from 'moment';

@Injectable({
   providedIn: 'root',
})
export class SessionCookieService {
   private static WEB_AGENT_SESSION_COOKIE_KEY = 'SamwebSession';
   private static SAMWIN_MANAGER_FORMS_COOKIE_KEY = 'samwinManager';

   public sessionCookieValue$: Observable<string>;

   constructor(private cookieService: CookieService) {
      this.sessionCookieValue$ = interval(500).pipe(
         map(() => this.sessionCookieValue),
         distinctUntilChanged(),
         shareReplay()
      );
   }

   public get sessionCookieValue(): string {
      return this.cookieService.get(SessionCookieService.WEB_AGENT_SESSION_COOKIE_KEY);
   }

   public setNewSessionId(newSessionId: string) {
      this.cookieService.set(SessionCookieService.WEB_AGENT_SESSION_COOKIE_KEY, newSessionId, null, '/', null, true, 'None');
   }

   public clearManagerCookie() {
      this.cookieService.delete(SessionCookieService.SAMWIN_MANAGER_FORMS_COOKIE_KEY, '/');
   }
}
